export enum subTimeline {
  DAY = "day",
  MINIDISCO = "minidisco",
  SHOWTIME = "showtime",
  LATE_NIGHT = "lateNight",
}
